import { WhitelabelConfig } from '../types/branding';

export const whitelabelConfig: WhitelabelConfig = {
  activeOrganization: 'wechter',
  organizations: {
    'wechter': {
      organizationId: 'wechter',
      organizationName: 'וועכטר',
      logo: {
        light: '/logos/main-full-light.png',
        dark: '/logos/main-full-dark.png',
      },
      themes: {
        light: {
          primary: '#1165EF',
          secondary: '#041D45',
          accent: '#FAB515',
          background: '#FFFFFF',
          surface: '#F8F9FA',
          text: {
            primary: '#121212',
            secondary: '#B5B5B5',
          },
          border: '#E3E6EB',
          error: '#FF0000',
          success: '#17DB4E',
          warning: '#FAB515',
        },
        dark: {
          primary: '#1165EF',
          secondary: '#041D45',
          accent: '#FAB515',
          background: '#121212',
          surface: '#1E1E1E',
          text: {
            primary: '#FFFFFF',
            secondary: '#B5B5B5',
          },
          border: '#E3E6EB',
          error: '#FF0000',
          success: '#17DB4E',
          warning: '#FAB515',
        },
      },
      typography: {
        fontFamily: 'DM Sans, system-ui, sans-serif',
        headingFontFamily: 'Poppins, system-ui, sans-serif',
        majorFontFamily: 'Secular One, system-ui, sans-serif',
        fontSize: {
          xs: '0.75rem',
          sm: '0.875rem',
          md: '1rem',
          lg: '1.125rem',
          xl: '1.25rem',
          '2xl': '1.5rem',
          '3xl': '1.875rem',
          '4xl': '2.25rem',
        },
        fontWeight: {
          normal: 300,
          medium: 400,
          semibold: 500,
          bold: 600,
        },
      },
      borderRadius: '0.5rem',
      spacing: {
        xs: '0.5rem',
        sm: '1rem',
        md: '1.5rem',
        lg: '2rem',
        xl: '2.5rem',
      },
    },
    'org-b': {
      organizationId: 'org-b',
      organizationName: 'Organization B',
      logo: {
        light: '/logos/org-b-light.svg',
        dark: '/logos/org-b-dark.svg',
      },
      themes: {
        light: {
          primary: '#9333ea',
          secondary: '#7c3aed',
          accent: '#ec4899',
          background: '#ffffff',
          surface: '#faf5ff',
          text: {
            primary: '#18181b',
            secondary: '#71717a',
          },
          border: '#e4e4e7',
          error: '#ef4444',
          success: '#22c55e',
          warning: '#f59e0b',
        },
        dark: {
          primary: '#a855f7',
          secondary: '#8b5cf6',
          accent: '#ec4899',
          background: '#18181b',
          surface: '#27272a',
          text: {
            primary: '#fafafa',
            secondary: '#a1a1aa',
          },
          border: '#3f3f46',
          error: '#ef4444',
          success: '#22c55e',
          warning: '#f59e0b',
        },
      },
      typography: {
        fontFamily: 'DM Sans, system-ui, sans-serif',
        fontSize: {
          xs: '0.75rem',
          sm: '0.875rem',
          md: '1rem',
          lg: '1.125rem',
          xl: '1.25rem',
          '2xl': '1.5rem',
          '3xl': '1.875rem',
          '4xl': '2.25rem',
        },
        fontWeight: {
          normal: 400,
          medium: 500,
          semibold: 600,
          bold: 700,
        },
      },
      borderRadius: '1rem',
      spacing: {
        xs: '0.5rem',
        sm: '1rem',
        md: '1.5rem',
        lg: '2rem',
        xl: '2.5rem',
      },
    },
  },
}; 